import React, { useEffect, useState, useContext } from "react";
import Layout from "components/sales/layout/layout";
import TablesSection from "components/sales/tableSection/tablesSection";
import localization from "assets/localization/localization";
import { Button } from "react-bootstrap";
import { BaseUrl } from "contexts/baseUrl/baseUrl";

const headers = [
  localization.enggID,
  localization.enggName,
  localization.department,
  localization.team,
  localization.userRole,
  localization.mobileNo,
  localization.email,
  localization.status,
  localization.action,
];

const SiteEngineerList = ({ getSiteEngineerList, siteEngineerList }) => {
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    if (getSiteEngineerList !== null)
      (async () => {
        setIsLoading(true);
        await getSiteEngineerList();
        setIsLoading(false);
      })();
  }, [getSiteEngineerList]);

  useEffect(() => {
    const tableData = [
      "engg_id",
      "engg_name",
      "department",
      "team",
      "user_role",
      "mobile_no",
      "email",
      "status",
    ];
    
    if (siteEngineerList && siteEngineerList.resultSets) {
      const data = siteEngineerList.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            Actions: {
              name: localization.viewDetails,
              link: `${baseUrl}/view-site-engineer-details/${element.engg_id}`,
            },
          }
          
        )
      );
      data && setListData(data);
      siteEngineerList.current_page && setCurrentPage(siteEngineerList.current_page);
      setPageCount(Math.ceil(siteEngineerList.total / siteEngineerList.per_page));
    }
  }, [siteEngineerList]);

  const onPageChange = async (val) => {
    setIsLoading(true);
    await getSiteEngineerList(val.selected + 1);
    setIsLoading(false);
  };

  return (
    <Layout title={localization.siteEngineer} isLoading={isLoading}>
      <TablesSection
        data={listData}
        headers={headers}
        pageCount={pageCount}
        currentPage={currentPage}
        onPageChange={onPageChange}
        detailList={siteEngineerList && siteEngineerList.resultSets}
      />
    </Layout>
  );
};

export default SiteEngineerList;
